/* Girl Friday Home — homepage section behaviour (hero slider, quick add, audience links, copy code) */
(function () {
  if (window.GFHome) return;
  var reduceMotion = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  /* ---------- Hero slider ---------- */
  function Hero(el) {
    this.el = el;
    this.slides = el.querySelectorAll('.gf-hero__slide');
    this.dots = el.querySelectorAll('.gf-hero__dot');
    this.index = 0;
    this.speed = (parseInt(el.getAttribute('data-speed'), 10) || 7) * 1000;
    this.autoplay = el.getAttribute('data-autoplay') === 'true' && !reduceMotion && this.slides.length > 1;
    var self = this;
    for (var i = 0; i < this.dots.length; i++) {
      (function (n) {
        self.dots[n].addEventListener('click', function () { self.go(n); self.restart(); });
      })(i);
    }
    el.addEventListener('mouseenter', function () { self.paused = true; });
    el.addEventListener('mouseleave', function () { self.paused = false; });
    el.addEventListener('focusin', function () { self.paused = true; });
    el.addEventListener('focusout', function () { self.paused = false; });
    // Swipe on touch devices
    var startX = null;
    el.addEventListener('touchstart', function (e) { startX = e.touches[0].clientX; }, { passive: true });
    el.addEventListener('touchend', function (e) {
      if (startX === null) return;
      var dx = e.changedTouches[0].clientX - startX;
      if (Math.abs(dx) > 50) { self.go(self.index + (dx < 0 ? 1 : -1)); self.restart(); }
      startX = null;
    });
    this.restart();
  }
  Hero.prototype.go = function (n) {
    var len = this.slides.length;
    if (!len) return;
    this.index = (n + len) % len;
    for (var i = 0; i < len; i++) {
      var on = i === this.index;
      this.slides[i].classList.toggle('is-active', on);
      this.slides[i].setAttribute('aria-hidden', on ? 'false' : 'true');
      var links = this.slides[i].querySelectorAll('a, button');
      for (var j = 0; j < links.length; j++) { if (on) links[j].removeAttribute('tabindex'); else links[j].setAttribute('tabindex', '-1'); }
      if (on) {
        var lazy = this.slides[i].querySelectorAll('img[loading="lazy"]');
        for (var k = 0; k < lazy.length; k++) lazy[k].loading = 'eager';
      }
      if (this.dots[i]) { if (on) this.dots[i].setAttribute('aria-current', 'true'); else this.dots[i].removeAttribute('aria-current'); }
    }
  };
  Hero.prototype.restart = function () {
    var self = this;
    clearInterval(this.timer);
    if (!this.autoplay) return;
    this.timer = setInterval(function () { if (!self.paused && !document.hidden) self.go(self.index + 1); }, this.speed);
  };
  Hero.prototype.destroy = function () { clearInterval(this.timer); };

  var heroes = {};
  function initHeroes(root) {
    var els = (root || document).querySelectorAll('[data-gf-hero]');
    for (var i = 0; i < els.length; i++) {
      var id = els[i].getAttribute('data-gf-hero');
      if (heroes[id]) heroes[id].destroy();
      heroes[id] = new Hero(els[i]);
      heroes[id].go(0);
    }
  }

  /* ---------- Delegated clicks ---------- */
  document.addEventListener('click', function (e) {
    var t = e.target;

    // Audience links: remember Home / Business navigation before leaving the page
    var aud = t.closest && t.closest('[data-gf-audience]');
    if (aud && typeof window.gfSetAudience === 'function') {
      window.gfSetAudience(aud.getAttribute('data-gf-audience'));
    }

    // Quick add
    var qa = t.closest && t.closest('[data-gf-quick-add]');
    if (qa) {
      e.preventDefault();
      quickAdd(qa);
      return;
    }

    // Copy discount code
    var code = t.closest && t.closest('[data-gf-copy]');
    if (code) {
      e.preventDefault();
      var value = code.getAttribute('data-gf-copy');
      var done = function () {
        code.classList.add('is-copied');
        var lbl = code.querySelector('[data-gf-copy-label]');
        if (lbl) { var old = lbl.textContent; lbl.textContent = code.getAttribute('data-copied-text') || 'Copied!'; setTimeout(function () { lbl.textContent = old; code.classList.remove('is-copied'); }, 2000); }
      };
      if (navigator.clipboard) navigator.clipboard.writeText(value).then(done, done); else done();
    }
  });

  function quickAdd(btn) {
    var id = btn.getAttribute('data-gf-quick-add');
    var label = btn.querySelector('[data-gf-qa-label]');
    var original = label ? label.textContent : '';
    var msg = btn.parentNode.querySelector('.gf-pcard__qa-msg');
    if (msg) msg.textContent = '';
    btn.classList.add('is-loading');
    var root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
    fetch(root + 'cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ items: [{ id: parseInt(id, 10), quantity: 1 }] })
    })
      .then(function (r) { return r.json().then(function (data) { return { ok: r.ok, data: data }; }); })
      .then(function (res) {
        btn.classList.remove('is-loading');
        if (!res.ok) {
          if (msg) msg.textContent = res.data.description || res.data.message || 'Could not add to cart.';
          return;
        }
        btn.classList.add('is-added');
        if (label) label.textContent = btn.getAttribute('data-added-text') || 'Added';
        setTimeout(function () { btn.classList.remove('is-added'); if (label) label.textContent = original; }, 2200);
        var cartType = window.theme && window.theme.settings && window.theme.settings.cartType;
        if (cartType === 'drawer' && document.getElementById('CartDrawer')) {
          var item = res.data.items ? res.data.items[0] : res.data;
          document.dispatchEvent(new CustomEvent('ajaxProduct:added', { detail: { product: item, addToCartBtn: btn } }));
        } else {
          window.location.href = root + 'cart';
        }
      })
      .catch(function () {
        btn.classList.remove('is-loading');
        if (msg) msg.textContent = 'Could not add to cart.';
      });
  }

  /* ---------- Boot + theme editor hooks ---------- */
  function boot() { initHeroes(document); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot); else boot();

  document.addEventListener('shopify:section:load', function (e) { initHeroes(e.target); });
  document.addEventListener('shopify:block:select', function (e) {
    var slide = e.target.closest && e.target.closest('.gf-hero__slide');
    if (!slide) return;
    var hero = slide.closest('[data-gf-hero]');
    var h = heroes[hero.getAttribute('data-gf-hero')];
    if (!h) return;
    h.paused = true;
    h.go(Array.prototype.indexOf.call(h.slides, slide));
  });
  document.addEventListener('shopify:block:deselect', function (e) {
    var hero = e.target.closest && e.target.closest('[data-gf-hero]');
    if (hero && heroes[hero.getAttribute('data-gf-hero')]) heroes[hero.getAttribute('data-gf-hero')].paused = false;
  });

  window.GFHome = { initHeroes: initHeroes };
})();
